import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'tj-payment-summary',
  templateUrl: './payment-summary.component.html',
  styleUrls: ['./payment-summary.component.scss'],
})
export class PaymentSummaryComponent implements OnChanges {
  @Input() netAmount: number = 0;
  @Input() ccFee: number = 0;
  @Input() total: number = 0;
  @Input() taxAmount: number = 0;
  @Input() showTax: boolean = false;
  @Input() showCCFee: boolean = false;
  @Input() taxRate: number = 0;

  ngOnChanges(changes: SimpleChanges) {
    // This will ensure the component updates when any input changes
    if (changes) {
      // Force update of the view
      this.netAmount = this.netAmount;
      this.ccFee = this.ccFee;
      this.total = this.total;
      this.taxAmount = this.taxAmount;
      this.showTax = this.showTax;
      this.showCCFee = this.showCCFee;
      this.taxRate = this.taxRate;
    }
  }
}
